import { useEffect, useState } from 'react';
import { useAuthSelector } from '@wajeez-web/stores/auth';

type Props = {
  children: JSX.Element;
  permissions: string[];
  multiple?: boolean;
};

const HasPermissionWrapperComponent = ({
  children,
  permissions,
  multiple = false,
}: Props) => {
  const [hasMultiplePermissions, setHasMultiplePermissions] = useState(false);

  const { permission } = useAuthSelector((state) => state.auth);

  useEffect(() => {
    for (const value of permissions) {
      if (!permission?.includes(value)) {
        setHasMultiplePermissions(false);

        break;
      } else {
        setHasMultiplePermissions(true);
      }
    }
  }, [permission, permissions]);

  if (!multiple) {
    return permissions.find((item) => permission?.includes(item))
      ? children
      : null;
  } else {
    return hasMultiplePermissions ? children : null;
  }
};

export default HasPermissionWrapperComponent;
